import {
  Box,
  Button,
  CardContent,
  Checkbox,
  Chip,
  Container,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  CheckBoxLabel,
  DocumentLabels,
  SelectSpan,
  StyledCard,
  StyledOutlineButton,
  VendorCardLabel,
} from "../../vendorRegistration/components/StepMain";
import { useSelector } from "react-redux";
import { Super } from "../../vendorRegistration/components/steps/cardTrial";
import {
  VendorCardTitle,
  VendorListHolder,
} from "../../vendorRegistration/components/steps/vendorReg";

import { useDispatch } from "react-redux";
import { styled as materialStyles } from "@mui/material/styles";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
  addbank,
  editbank,
  getBanksIdWise,
  validatebank,
  validatebankAccount,
} from "../redux/bankDetailsSlice";
import { history } from "../../../app/history";
import LocalStorage from "../../../utilities/localStorage";
// import { bank_info } from "../../../utilities/helper";
import { ExpandMore } from "@mui/icons-material";
import { getCountries, getStates } from "../redux/bankDetailsSlice";
import { message } from "antd";
import { useParams } from "react-router-dom";

const Input = materialStyles("input")({
  display: "none",
});

function BankDetailsContent1({
  l_index,
  createdUser,
  handleBack,
  activeStep,
  is_domestic,
  company_id,
}) {
  const [loading, setLoading] = useState(false);
  const { countries, states } = useSelector((state) => state.bankdetails);
  const [bankInfo, setBankInfo] = useState({});
  // const [bankInfoId, setBankInfoID] = useState(useParams("id")?.id ?? null);
  // console.log("bankInfoId: ", bankInfoId);

  const bankInfoId = useParams()?.id;

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({ defaultValues: bankInfo });
  const Countries = (payload) => {
    dispatch(getCountries(payload));
  };
  const getStateByCountryId = (payload) => {
    dispatch(getStates(payload));
  };
  const watchFields = watch(["rtgs", "bankStatement", "ca"]);
  // const { bankdetails } = useSelector((state) => state.bankdetails);
  const {
    bankValidation: { is_bank_validate, is_ifsc_validate },
  } = useSelector((state) => state.bankdetails);
  const [checkedPrimary, setCheckedPrimary] = useState(false);

  const dispatch = useDispatch();

  const user = LocalStorage.getItem("tata_login_user");
  const clientId = LocalStorage.getItem("client")?.id;
  const primary_role = user.roles[0];

  const handleChange = (event) => {
    if (event.target.checked) {
      setCheckedPrimary(true);
    } else {
      setCheckedPrimary(false);
    }
  };

  const onSubmit = (payload) => {
    setLoading(true);
    if (bankInfoId) {
      dispatch(editbank(payload)).then((response) => {
        if (response?.payload?.success) {
          setLoading(false);
          if (primary_role === "user") {
            history.push("/app");
          }
        }
        setLoading(false);
      });
    } else {
      dispatch(addbank(payload)).then((response) => {
        if (response?.payload?.success) {
          setLoading(false);
          if (primary_role === "user") {
            history.push("/app");
          }
          if (primary_role === "officer") {
            history.push("/app/vendor");
          }
        }
        setLoading(false);
      });
    }
  };

  useEffect(() => {
    Countries();
    if (bankInfoId) {
      dispatch(getBanksIdWise(bankInfoId)).then((data) => {
        const { data: response } = data.payload;
        console.log("response: ", response);
        setBankInfo({
          account_name: response?.account_name,
          account_number: response?.account_number,
          address_line_one: response?.address_line_one,
          bank_name: response?.bank_name,
          branch_name: response?.branch_name,
          city: response?.city,
          currency: response?.currency,
          ifsc_code: response?.ifsc_code,
          swift_code: response?.swift_code,
          is_primary_account: response?.is_primary_account,
          state: response?.state,
        });
        setCheckedPrimary(response?.is_primary_account);
        setIfscCode(response?.ifsc_code);
        if (response?.Bank_Documents[0]?.bank_statement_image_name) {
          setBankStatment({
            name: response?.Bank_Documents[0]?.bank_statement_image_name,
            image: response?.Bank_Documents[0]?.bank_statement_image,
          });
        }
        console.log(
          "response?.Bank_Documents[0]?.cancelled_cheque_image: ",
          response?.Bank_Documents[0]?.cancelled_cheque_image
        );

        if (response?.Bank_Documents[0]?.cancelled_cheque_image) {
          setCancelledCheque({
            name: response?.Bank_Documents[0]?.cancelled_cheque_image_name,
            image: response?.Bank_Documents[0]?.cancelled_cheque_image,
          });
        }
        if (response?.Bank_Documents[0]?.rtgs_authorization_letter_image_name) {
          setRtgsDoc({
            name: response?.Bank_Documents[0]
              ?.rtgs_authorization_letter_image_name,
            image: response?.Bank_Documents[0]?.rtgs_authorization_letter_image,
          });
        }
        if (
          response?.Bank_Documents[0]
            ?.bank_passbook_copy_with_bank_stamp_image_name
        ) {
          setPassBook({
            name: response?.Bank_Documents[0]
              ?.bank_passbook_copy_with_bank_stamp_image_name,
            image:
              response?.Bank_Documents[0]
                ?.bank_passbook_copy_with_bank_stamp_image,
          });
        }
        if (response?.Bank_Documents[0]?.supporting_document_image_name) {
          setSupportingDoc({
            name: response?.Bank_Documents[0]?.supporting_document_image_name,
            image: response?.Bank_Documents[0]?.supporting_document_image,
          });
        }
      });
    }
    // eslint-disable-next-line
  }, []);
  const [supportingDoc, setSupportingDoc] = useState("");
  const [rtgsDoc, setRtgsDoc] = useState("");
  const [cancelledCheque, setCancelledCheque] = useState("");
  const [bankStatement, setBankStatment] = useState("");
  const [passBook, setPassBook] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [showBankDetails, setShowBankDetails] = useState(false);
  const [disabled, setDisabled] = useState(is_domestic ? true : false);
  const [disableEditBtn, setDisableEditBtn] = useState(false);

  const handleIfscChange = (value) => {
    setIfscCode(value);
    setDisableEditBtn(true);
  };

  const OnClickValidateBankAccount = (payload) => {
    dispatch(validatebankAccount(payload)).then((response) => {
      if (response.payload.success) {
        setDisabled(false);
        setShowBankDetails(true);
        const {
          data: { ifsc_details, account_holder_name },
        } = response.payload;
        if (ifsc_details) {
          setBankInfo({
            ...bankInfo,
            address_line_one: ifsc_details?.address,
            bank_name: ifsc_details?.bank,
            branch_name: ifsc_details?.branch,
            swift_code: ifsc_details?.swiftCode,
            city: ifsc_details?.city,
            state: ifsc_details?.state,
            account_name: account_holder_name,
          });
        }
      }
    });
  };

  const validateBank = () => {
    if (
      !is_bank_validate ||
      watch("account_number") !== bankInfo?.account_number
    ) {
      const payload = {
        account_name: watch("account_name"),
        account_number: watch("account_number") || bankInfo?.account_number,
        ifsc_code: ifscCode,
      };
      OnClickValidateBankAccount(payload);
    } else {
      dispatch(validatebank({ ifsc: ifscCode })).then((response) => {
        if (response.payload.success) {
          setDisabled(false);
          setShowBankDetails(true);
          const { data } = response.payload;
          setBankInfo({
            ...bankInfo,
            address_line_one: data?.address,
            bank_name: data?.bank,
            branch_name: data?.branch,
            swift_code: data?.swiftCode,
            city: data?.city,
            state: data?.state,
          });
        }
      });
    }
  };

  const handleNext = (data) => {
    if (clientId === 2 || clientId === 5) {
      if (rtgsDoc === "" && cancelledCheque === "" && bankStatement === "") {
        return message.error(
          "Atleast one document require in mandatory fields"
        );
      }
    }
    console.log("bank_info: ", bankInfo);

    var formData = new FormData();
    setLoading(false);
    if (primary_role === "officer") {
      data = { ...data, user_id: createdUser.id, company_id };
    }
    if (bankInfoId) {
      data = { ...data, bankInfoId };
    }
    if (is_domestic) {
      formData.append("data", JSON.stringify(data));
      formData.append("account_name", bankInfo.account_name);
      formData.append("account_number", bankInfo.account_number);
      formData.append("ifsc", ifscCode);
      formData.append("address_line_one", bankInfo.address_line_one);
      formData.append("branch_name", bankInfo.branch_name);
      formData.append("bank_name", bankInfo.bank_name);
      formData.append("countryCode", "IN");
      formData.append("city", bankInfo.city);
      formData.append("state", bankInfo.state);
      formData.append("swift_code", bankInfo.swiftCode);
      formData.append("rtgs_authorization_letter_image", rtgsDoc);
      formData.append("cancelled_cheque_image", cancelledCheque);
      formData.append("bank_statement_image", bankStatement);
      formData.append("bank_passbook_copy_with_bank_stamp_image", passBook);
      formData.append("supporting_document_image", supportingDoc);
      formData.append("is_primary_account", checkedPrimary);
    } else {
      formData.append("data", JSON.stringify(data));
      formData.append("account_name", bankInfo.account_name);
      formData.append("account_number", bankInfo.account_number);
      formData.append("swift_code", bankInfo.swift_code);
      formData.append("branch_name", bankInfo.branch_name);
      formData.append("bank_name", bankInfo.bank_name);
      formData.append("countryCode", bankInfo.country);
      formData.append("city", bankInfo.city);
      formData.append("state", bankInfo.state);
      formData.append("rtgs_authorization_letter_image", rtgsDoc);
      formData.append("cancelled_cheque_image", cancelledCheque);
      formData.append("bank_statement_image", bankStatement);
      formData.append("bank_passbook_copy_with_bank_stamp_image", passBook);
      formData.append("supporting_document_image", supportingDoc);
      formData.append("is_primary_account", checkedPrimary);
    }

    onSubmit(formData);
  };

  const onInputChange = (e) => {
    // e.persist();

    if (e.target.name === "country") {
      getStateByCountryId(e.target.value);
    }

    setBankInfo({
      ...bankInfo,
      [e.target.name]: e.target.value,
    });
  };

  const payment_info_officer = (
    <CardContent>
      <Container fixed>
        <Grid>
          <VendorCardTitle>Payment Information</VendorCardTitle>
        </Grid>
        <VendorListHolder>
          <li>
            Enter account name, account number, and IFSC Code to validate bank
            details.
          </li>
          <li>Bank details will be auto-populated once bank is validated.</li>
          <li>
            Proceed to add supporting documents of bank once bank is validated.
          </li>
        </VendorListHolder>
        <br />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6}>
            <VendorCardLabel>
              {is_domestic ? "Account Number" : "IBA Number"}
              <Super>*</Super>
            </VendorCardLabel>
            <TextField
              sx={{
                input: {
                  fontSize: "14px",
                  fontFamily: "var(--font-family-reg)",
                },
              }}
              InputProps={{
                disableUnderline: false,
                disableInjectingGlobalStyles: true,
              }}
              InputLabelProps={{
                disableAnimation: true,
                disableInjectingGlobalStyles: true,
              }}
              placeholder="Enter account number"
              size="small"
              variant="standard"
              style={{ width: "100%", paddingTop: "3px" }}
              name="account_number"
              {...register("account_number", {
                value: bankInfo?.account_number ?? "",
                pattern: {
                  value: /-?\d*\.?\d{1,2}/,
                  message: "Invalid account number",
                },
                required: "Please Enter account number",
              })}
              error={Boolean(errors?.account_number)}
              helperText={errors.account_number?.message}
              value={bankInfo?.account_number ?? ""}
              onChange={onInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <VendorCardLabel>
              Account Holder Name <Super>*</Super>
            </VendorCardLabel>
            <TextField
              sx={{
                input: {
                  fontSize: "14px",
                  fontFamily: "var(--font-family-reg)",
                },
              }}
              InputProps={{
                disableUnderline: false,
                disableInjectingGlobalStyles: true,
              }}
              InputLabelProps={{
                disableAnimation: true,
                disableInjectingGlobalStyles: true,
              }}
              placeholder="Enter name of account holder"
              size="small"
              variant="standard"
              style={{ width: "100%", paddingTop: "3px" }}
              name="account_name"
              {...register("account_name", {
                value: bankInfo?.account_name,
                required: "Please enter account name",
              })}
              error={Boolean(errors?.account_name)}
              disabled
              helperText={errors.account_name?.message}
              value={bankInfo?.account_name ?? ""}
              onChange={onInputChange}
            />
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={2}>
          {is_domestic ? (
            <>
              <Grid item xs={12} sm={6} md={6}>
                <VendorCardLabel>
                  IFSC Code <Super>*</Super>
                </VendorCardLabel>
                <TextField
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  InputProps={{
                    disableUnderline: false,
                    disableInjectingGlobalStyles: true,
                  }}
                  InputLabelProps={{
                    disableAnimation: true,
                    disableInjectingGlobalStyles: true,
                  }}
                  placeholder="Enter IFSC Code"
                  size="small"
                  variant="standard"
                  style={{ width: "100%", paddingTop: "3px" }}
                  name="ifsc"
                  {...register("ifsc", {
                    value: ifscCode ?? "",
                    pattern: {
                      value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                      message: "Please Enter valid IFSC",
                    },
                    required: "Please enter IFSC",
                  })}
                  onChange={(e) => handleIfscChange(e.target.value)}
                  error={Boolean(errors?.ifsc)}
                  value={ifscCode ?? ""}
                  helperText={errors.ifsc?.message}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <Button
                  variant="contained"
                  sx={{ marginTop: "10px" }}
                  onClick={(e) => validateBank(e)}
                  disabled={
                    !ifscCode &&
                    (!watch("account_number") || !bankInfo.account_number)
                  }
                >
                  {"Validate BANK Account"}
                </Button>
              </Grid>
            </>
          ) : (
            ""
          )}
        </Grid>
        <br />
        {showBankDetails || bankInfoId ? (
          <Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6}>
                <VendorCardLabel>
                  Bank Name<Super>*</Super>
                </VendorCardLabel>
                <span>
                  <b>{bankInfo.bank_name}</b>
                </span>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <VendorCardLabel>
                  Branch Name<Super>*</Super>
                </VendorCardLabel>
                <span>
                  <b>{bankInfo?.branch_name}</b>
                </span>
              </Grid>
            </Grid>
            <br />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6}>
                <VendorCardLabel>
                  Address line 1<Super>*</Super>
                </VendorCardLabel>
                <span>
                  <b>{bankInfo?.address_line_one}</b>
                </span>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          ""
        )}
        {!is_domestic && (
          <Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <VendorCardLabel>
                  Bank name<Super>*</Super>
                </VendorCardLabel>
                <TextField
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  InputProps={{
                    disableUnderline: false,
                    disableInjectingGlobalStyles: true,
                  }}
                  InputLabelProps={{
                    disableAnimation: true,
                    disableInjectingGlobalStyles: true,
                  }}
                  placeholder="Enter bank name"
                  size="small"
                  variant="standard"
                  style={{ width: "100%", paddingTop: "3px" }}
                  name="bank_name"
                  {...register("bank_name", {
                    value: bankInfo?.bank_name,
                    required: "Please enter bank name",
                  })}
                  error={Boolean(errors?.bank_name)}
                  helperText={errors.bank_name?.message}
                  value={bankInfo?.bank_name}
                  onChange={onInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <VendorCardLabel>
                  Branch name<Super>*</Super>
                </VendorCardLabel>
                <TextField
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  InputProps={{
                    disableUnderline: false,
                    disableInjectingGlobalStyles: true,
                  }}
                  InputLabelProps={{
                    disableAnimation: true,
                    disableInjectingGlobalStyles: true,
                  }}
                  placeholder="Enter branch"
                  size="small"
                  variant="standard"
                  style={{ width: "100%", paddingTop: "3px" }}
                  name="branch_name"
                  {...register("branch_name", {
                    value: bankInfo?.branch_name ?? "",
                    required: "Please enter branch name",
                  })}
                  error={Boolean(errors?.branch_name)}
                  helperText={errors.branch_name?.message}
                  value={bankInfo?.branch_name ?? ""}
                  onChange={onInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <VendorCardLabel>Swift code</VendorCardLabel>
                <TextField
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  InputProps={{
                    disableUnderline: false,
                    disableInjectingGlobalStyles: true,
                  }}
                  InputLabelProps={{
                    disableAnimation: true,
                    disableInjectingGlobalStyles: true,
                  }}
                  placeholder="Enter swift code"
                  size="small"
                  variant="standard"
                  style={{ width: "100%", paddingTop: "3px" }}
                  name="swift_code"
                  {...register("swift_code", {
                    value: bankInfo?.swift_code ?? "",
                    required: false,
                  })}
                  value={bankInfo?.swift_code ?? ""}
                  onChange={onInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl
                  variant="standard"
                  style={{ width: "100%" }}
                  error={Boolean(errors?.country)}
                >
                  <VendorCardLabel>
                    Country<Super>*</Super>
                  </VendorCardLabel>
                  <Select
                    sx={{
                      fontFamily: "var(--font-family-reg)",
                      fontSize: "14px",
                    }}
                    displayEmpty
                    defaultValue=""
                    IconComponent={() => (
                      <ExpandMore style={{ color: "#A5A5BA" }} />
                    )}
                    labelId="demo-simple-select-standard-label"
                    id="country"
                    name="country"
                    {...register("country", {
                      value: bankInfo?.country ?? "",
                      required: "Please select country",
                    })}
                    onChange={onInputChange}
                    value={bankInfo?.country ?? ""}
                  >
                    <MenuItem value="">
                      <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                        Select country
                      </span>
                    </MenuItem>
                    {countries.length
                      ? countries.map((item, index) => (
                          <MenuItem value={item.id} key={index}>
                            <SelectSpan>{item.CountryName}</SelectSpan>
                          </MenuItem>
                        ))
                      : "No countries available"}
                  </Select>
                  <FormHelperText>{errors.country?.message}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl
                  variant="standard"
                  style={{ width: "100%" }}
                  error={Boolean(errors?.state)}
                >
                  <VendorCardLabel>
                    State<Super> *</Super>
                  </VendorCardLabel>
                  <Select
                    sx={{
                      fontFamily: "var(--font-family-reg)",
                      fontSize: "14px",
                    }}
                    displayEmpty
                    defaultValue=""
                    IconComponent={() => (
                      <ExpandMore style={{ color: "lightgray" }} />
                    )}
                    labelId="demo-simple-select-standard-label"
                    id="state"
                    label="state"
                    name="state"
                    {...register("state", {
                      value: bankInfo?.state ?? "",
                      required: "Please select state",
                    })}
                    error={Boolean(errors?.state)}
                    value={bankInfo?.state ?? ""}
                    onChange={onInputChange}
                  >
                    <MenuItem value="">
                      <span style={{ fontSize: "14px", color: "lightgray" }}>
                        Select state
                      </span>
                    </MenuItem>
                    {states.length
                      ? states.map((item, index) => (
                          <MenuItem value={item.StateName} key={index}>
                            <SelectSpan>{item.StateName}</SelectSpan>
                          </MenuItem>
                        ))
                      : "asdf"}
                  </Select>
                  <FormHelperText>{errors.state?.message}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <VendorCardLabel>
                  City<Super>*</Super>
                </VendorCardLabel>
                <TextField
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  InputProps={{
                    disableUnderline: false,
                    disableInjectingGlobalStyles: true,
                  }}
                  InputLabelProps={{
                    disableAnimation: true,
                    disableInjectingGlobalStyles: true,
                  }}
                  placeholder="Enter city name"
                  size="small"
                  variant="standard"
                  name="city"
                  style={{ width: "100%", paddingTop: "3px" }}
                  {...register("city", {
                    value: bankInfo?.city ?? "",
                    required: "Please enter city",
                  })}
                  error={Boolean(errors?.city)}
                  helperText={errors.city?.message}
                  value={bankInfo?.city ?? ""}
                  onChange={onInputChange}
                />
              </Grid>
            </Grid>
          </Grid>
        )}
      </Container>
    </CardContent>
  );

  const documents = (
    <CardContent>
      <Container fixed>
        <Grid container spacing={2}>
          <Grid item xs={6} md={6}>
            <VendorCardTitle>Supporting Documents</VendorCardTitle>
          </Grid>
          <Grid item xs={6} md={6}></Grid>
        </Grid>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            <span variant="outlined" component="span" style={{ width: "50%" }}>
              <DocumentLabels>
                Upload cancelled cheque <Super>*</Super>
              </DocumentLabels>
            </span>
          </Grid>
          <Grid item xs={6}>
            <FormControl
              variant="standard"
              style={{ width: "100%" }}
              error={Boolean(errors?.cancelledCheque)}
            >
              {cancelledCheque !== "" ? (
                <>
                  <span
                    style={{
                      color: "#4945FF",
                      fontSize: "13px",
                      fontFamily: "var(--font-family-reg)",
                    }}
                  >
                    <Chip
                      style={{
                        width: "150px",
                        color: "#4945FF",
                        margin: "5px",
                        borderRadius: "5px",
                        border: "1px solid #D9D8FF",
                        background: "#F0F0FF",
                      }}
                      label={cancelledCheque.name}
                      value={cancelledCheque.name}
                      name="chips"
                    />
                    <HighlightOffIcon
                      sx={{ color: "#4945FF", paddingBottom: "2px" }}
                      fontSize="medium"
                      onClick={(e) => setCancelledCheque("")}
                    />
                  </span>
                </>
              ) : (
                <label htmlFor="cancelledCheque">
                  <Input
                    {...register("cancelledCheque", {
                      required:
                        clientId === 2 || clientId === 5
                          ? false
                          : "Please upload cancelled cheque copy",
                    })}
                    accept="*"
                    id="cancelledCheque"
                    name="cancelledCheque"
                    onChange={(e) => setCancelledCheque(e.target.files[0])}
                    type="file"
                  />
                  <StyledOutlineButton variant="outlined" component="span">
                    Upload
                  </StyledOutlineButton>
                  <span>{cancelledCheque.name}</span>
                </label>
              )}
              {cancelledCheque === "" ? (
                <FormHelperText>
                  {errors.cancelledCheque?.message}
                </FormHelperText>
              ) : (
                ""
              )}
            </FormControl>
          </Grid>
        </Grid>
        {clientId === 2 || clientId === 5 ? (
          <p style={{ textAlign: "center", width: "50%" }}>OR</p>
        ) : (
          ""
        )}

        <br />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            <span variant="outlined" component="span" style={{ width: "50%" }}>
              <DocumentLabels>
                {clientId === 2 || clientId === 5 ? (
                  <>
                    Bank Mandate duly stamped showing Account & RTGS details
                    <Super>*</Super>
                  </>
                ) : (
                  " Upload RTGS authorization letter"
                )}
              </DocumentLabels>
            </span>
          </Grid>

          <Grid item xs={6}>
            <FormControl
              variant="standard"
              style={{ width: "100%" }}
              error={Boolean(errors?.rtgs)}
            >
              {rtgsDoc !== "" ? (
                <>
                  <span
                    style={{
                      color: "#4945FF",
                      fontSize: "13px",
                      fontFamily: "var(--font-family-reg)",
                    }}
                  >
                    <Chip
                      style={{
                        width: "150px",
                        color: "#4945FF",
                        margin: "5px",
                        borderRadius: "5px",
                        border: "1px solid #D9D8FF",
                        background: "#F0F0FF",
                      }}
                      label={rtgsDoc.name}
                      value={rtgsDoc.name}
                      name="chips"
                    />
                    <HighlightOffIcon
                      sx={{ color: "#4945FF", paddingBottom: "2px" }}
                      fontSize="medium"
                      onClick={(e) => setRtgsDoc("")}
                    />
                  </span>
                </>
              ) : (
                <label htmlFor="rtgs">
                  <Input
                    {...register("rtgs")}
                    accept="*"
                    id="rtgs"
                    onChange={(e) => setRtgsDoc(e.target.files[0])}
                    type="file"
                  />

                  <StyledOutlineButton variant="outlined" component="span">
                    Upload
                  </StyledOutlineButton>
                </label>
              )}
              {rtgsDoc === "" ? (
                <FormHelperText>{errors.rtgs?.message}</FormHelperText>
              ) : (
                ""
              )}
            </FormControl>
          </Grid>
        </Grid>
        {clientId === 2 || clientId === 5 ? (
          <p style={{ textAlign: "center", width: "50%" }}>OR</p>
        ) : (
          ""
        )}
        <br />

        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            <span variant="outlined" component="span" style={{ width: "50%" }}>
              <DocumentLabels>
                Upload bank statement
                {clientId === 2 || clientId === 5 ? <Super>*</Super> : ""}
              </DocumentLabels>
            </span>
          </Grid>
          <Grid item xs={6}>
            {bankStatement !== "" ? (
              <>
                <span
                  style={{
                    color: "#4945FF",
                    fontSize: "13px",
                    fontFamily: "var(--font-family-reg)",
                  }}
                >
                  <Chip
                    style={{
                      width: "150px",
                      color: "#4945FF",
                      margin: "5px",
                      borderRadius: "5px",
                      border: "1px solid #D9D8FF",
                      background: "#F0F0FF",
                    }}
                    label={bankStatement.name}
                    value={bankStatement.name}
                    name="chips"
                  />
                  <HighlightOffIcon
                    sx={{ color: "#4945FF", paddingBottom: "2px" }}
                    fontSize="medium"
                    onClick={(e) => setBankStatment("")}
                  />
                </span>
              </>
            ) : (
              <label htmlFor="bankStatement">
                <Input
                  {...register("bankStatement")}
                  accept="*"
                  id="bankStatement"
                  name="bankStatement"
                  onChange={(e) => setBankStatment(e.target.files[0])}
                  type="file"
                />
                <StyledOutlineButton variant="outlined" component="span">
                  Upload
                </StyledOutlineButton>
                <span>{bankStatement.name}</span>
              </label>
            )}
          </Grid>
        </Grid>

        <br />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            <span variant="outlined" component="span" style={{ width: "50%" }}>
              <DocumentLabels>
                Upload bank passbook copy with bank stamp
              </DocumentLabels>
            </span>
          </Grid>
          <Grid item xs={6}>
            {passBook !== "" ? (
              <>
                <span
                  style={{
                    color: "#4945FF",
                    fontSize: "13px",
                    fontFamily: "var(--font-family-reg)",
                  }}
                >
                  <Chip
                    style={{
                      width: "150px",
                      color: "#4945FF",
                      margin: "5px",
                      borderRadius: "5px",
                      border: "1px solid #D9D8FF",
                      background: "#F0F0FF",
                    }}
                    label={passBook.name}
                    value={passBook.name}
                    name="chips"
                  />
                  <HighlightOffIcon
                    sx={{ color: "#4945FF", paddingBottom: "2px" }}
                    fontSize="medium"
                    onClick={(e) => setPassBook("")}
                  />
                </span>
              </>
            ) : (
              <label htmlFor="passBook">
                <Input
                  accept="*"
                  id="passBook"
                  name="passBook"
                  onChange={(e) => setPassBook(e.target.files[0])}
                  type="file"
                />
                <StyledOutlineButton variant="outlined" component="span">
                  Upload
                </StyledOutlineButton>
                <span>{passBook.name}</span>
              </label>
            )}
          </Grid>
        </Grid>
        <br />
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            <span variant="outlined" component="span" style={{ width: "50%" }}>
              <DocumentLabels>Upload supporting document</DocumentLabels>
            </span>
          </Grid>
          <Grid item xs={6}>
            <FormControl variant="standard" style={{ width: "100%" }}>
              {supportingDoc !== "" ? (
                <>
                  <span
                    style={{
                      color: "#4945FF",
                      fontSize: "13px",
                      fontFamily: "var(--font-family-reg)",
                    }}
                  >
                    <Chip
                      style={{
                        width: "150px",
                        color: "#4945FF",
                        margin: "5px",
                        borderRadius: "5px",
                        border: "1px solid #D9D8FF",
                        background: "#F0F0FF",
                      }}
                      label={supportingDoc.name}
                      value={supportingDoc.name}
                      name="chips"
                    />
                    <HighlightOffIcon
                      sx={{ color: "#4945FF", paddingBottom: "2px" }}
                      fontSize="medium"
                      onClick={(e) => setSupportingDoc("")}
                    />
                  </span>
                </>
              ) : (
                <label htmlFor="supportingDoc">
                  <Input
                    {...register("supportingDoc", {
                      required: false,
                    })}
                    accept="*"
                    id="supportingDoc"
                    onChange={(e) => setSupportingDoc(e.target.files[0])}
                    type="file"
                  />
                  <StyledOutlineButton variant="outlined" component="span">
                    Upload
                  </StyledOutlineButton>
                </label>
              )}
            </FormControl>
          </Grid>
        </Grid>

        <br />
        <FormControlLabel
          control={
            <Checkbox
              sx={{
                color: "lightgray",
                "&.Mui-checked": {
                  color: "#4059e5",
                },
              }}
              value={checkedPrimary}
              onChange={handleChange}
            />
          }
          label={
            <CheckBoxLabel>Make this my primary bank account</CheckBoxLabel>
          }
        />
        {watchFields.filter(Boolean).length === 0 && (
          <p>Please select at least one image.</p>
        )}
      </Container>
    </CardContent>
  );

  return (
    <>
      <form onSubmit={handleSubmit(handleNext)}>
        <StyledCard>{payment_info_officer}</StyledCard>
        <StyledCard>{documents}</StyledCard>
        <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
          <Button
            color="inherit"
            disabled={!activeStep}
            onClick={handleBack}
            sx={{ mr: 1, display: "none" }}
          >
            Back
          </Button>

          <Box sx={{ flex: "1 1 auto" }} />
          <LoadingButton
            sx={{
              textTransform: "none",
              background: "var(--button-color)",
              width: "200px",
              height: "40px",
            }}
            color="success"
            variant="contained"
            type="submit"
            disabled={bankInfoId && !disableEditBtn ? false : disabled}
            loading={loading}
            loadingPosition="start"
          >
            {bankInfoId ? "Edit Bank" : "Add Bank"}
          </LoadingButton>
        </Box>
      </form>
    </>
  );
}

export default BankDetailsContent1;
